module.exports = __webpack_public_path__ + "static/media/expo-4-3-2.67927b9e.png";